/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Pick_3_NeedInputs */

const en_pc_alt_pick_3_need = /** @type {(inputs: Pc_Alt_Pick_3_NeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You only need to merge or split files`)
};

const zh_pc_alt_pick_3_need = /** @type {(inputs: Pc_Alt_Pick_3_NeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`只需要合并或拆分文件`)
};

/**
* | output |
* | --- |
* | "You only need to merge or split files" |
*
* @param {Pc_Alt_Pick_3_NeedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_pick_3_need = /** @type {((inputs?: Pc_Alt_Pick_3_NeedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Pick_3_NeedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_pick_3_need(inputs)
	return zh_pc_alt_pick_3_need(inputs)
});
export { pc_alt_pick_3_need as "pc.alt.pick.3.need" }